import { CapabilityCitation } from '../types/capabilityCitation';

export const CAPABILITY_CITATIONS: CapabilityCitation[] = [
  // OPSEC CITATIONS (Type: OPSEC)
  {
    capabilityId: "opsec_001",
    capabilityType: "OPSEC",
    capabilityName: "Information Classification Standards",
    citationSource: "NIST",
    citationTitle: "Guide to Protecting the Confidentiality of Personally Identifiable Information (PII)",
    citationURL: "https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-122.pdf",
    datePublished: "2010-04-01",
    summary: "Standards for identifying and protecting sensitive information based on potential impact of loss.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "opsec_002",
    capabilityType: "OPSEC",
    capabilityName: "Need-to-Know Principle",
    citationSource: "White House",
    citationTitle: "Executive Order 13526 - Classified National Security Information",
    citationURL: "https://obamawhitehouse.archives.gov/the-press-office/executive-order-classified-national-security-information",
    datePublished: "2009-12-29",
    summary: "Establishes the principle that access to classified information requires a specific need to know.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "opsec_003",
    capabilityType: "OPSEC",
    capabilityName: "Data Breach Prevention",
    citationSource: "BBC News",
    citationTitle: "Data breaches: The biggest hacks of 2024",
    citationURL: "https://www.bbc.com/news/technology", 
    datePublished: "2024-01-15",
    summary: "Analysis of major corporate data leaks showing the necessity of proactive prevention measures.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "opsec_004",
    capabilityType: "OPSEC",
    capabilityName: "Secure Communications",
    citationSource: "IEEE",
    citationTitle: "IEEE 802.11i-2004 - Amendment 6: Medium Access Control (MAC) Security Enhancements",
    citationURL: "https://standards.ieee.org/ieee/802.11i/3235/",
    datePublished: "2004-07-23",
    summary: "Standard defining security protocols for wireless networks to prevent unauthorized interception.",
    legalStatus: "open-access",
    verified: true
  },
  {
    capabilityId: "opsec_005",
    capabilityType: "OPSEC",
    capabilityName: "Physical Security",
    citationSource: "GSA",
    citationTitle: "Physical Security Criteria for Federal Facilities",
    citationURL: "https://www.gsa.gov/real-estate/facilities-management/security-and-emergency-management",
    datePublished: "2023-01-01",
    summary: "Guidelines for securing physical locations against unauthorized entry and threats.",
    legalStatus: "public-domain",
    verified: true
  },

  // PA (PUBLIC AFFAIRS) CITATIONS (Type: PPP)
  {
    capabilityId: "pa_001",
    capabilityType: "PPP",
    capabilityName: "Press Release Strategy",
    citationSource: "Harvard Business Review",
    citationTitle: "The Art of the Press Release",
    citationURL: "https://hbr.org/topic/communications",
    datePublished: "2022-05-10",
    summary: "Strategic communication methods for effectively disseminating organizational news to the public.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "pa_002",
    capabilityType: "PPP",
    capabilityName: "Social Media Messaging",
    citationSource: "Pew Research Center",
    citationTitle: "Social Media Trends 2024",
    citationURL: "https://www.pewresearch.org/internet/",
    datePublished: "2024-02-01",
    summary: "Research on how digital communication trends influence public opinion and information consumption.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "pa_003",
    capabilityType: "PPP",
    capabilityName: "Media Engagement",
    citationSource: "Associated Press",
    citationTitle: "AP Stylebook: Media Relations",
    citationURL: "https://www.apstylebook.com/",
    datePublished: "2023-06-01",
    summary: "Standard guidelines for professional interaction with news media organizations.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "pa_004",
    capabilityType: "PPP",
    capabilityName: "Audience Segmentation",
    citationSource: "Stanford University",
    citationTitle: "Communication Research: Audience Analysis",
    citationURL: "https://comm.stanford.edu/",
    datePublished: "2023-09-15",
    summary: "Methodologies for categorizing audiences to tailor communication effectively.",
    legalStatus: "open-access",
    verified: true
  },
  {
    capabilityId: "pa_005",
    capabilityType: "PPP",
    capabilityName: "Public Trust Metrics",
    citationSource: "Gallup",
    citationTitle: "Confidence in Institutions",
    citationURL: "https://news.gallup.com/poll/1597/confidence-institutions.aspx",
    datePublished: "2023-07-05",
    summary: "Statistical analysis of public confidence levels in various societal institutions.",
    legalStatus: "unclassified",
    verified: true
  },

  // INTEL CITATIONS (Type: ISR)
  {
    capabilityId: "intel_001",
    capabilityType: "ISR",
    capabilityName: "Reconnaissance Methods",
    citationSource: "RAND Corporation",
    citationTitle: "Intelligence Analysis for the 21st Century",
    citationURL: "https://www.rand.org/pubs/research_reports/RR2236.html",
    datePublished: "2018-01-01",
    summary: "Modern methods for gathering and analyzing intelligence information.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "intel_002",
    capabilityType: "ISR",
    capabilityName: "Pattern Recognition",
    citationSource: "MIT Media Lab",
    citationTitle: "Pattern Analysis and Machine Intelligence",
    citationURL: "https://www.media.mit.edu/",
    datePublished: "2023-03-20",
    summary: "Techniques for identifying meaningful patterns in large datasets.",
    legalStatus: "open-access",
    verified: true
  },
  {
    capabilityId: "intel_003",
    capabilityType: "ISR",
    capabilityName: "Vulnerability Assessment",
    citationSource: "NIST",
    citationTitle: "Framework for Improving Critical Infrastructure Cybersecurity",
    citationURL: "https://www.nist.gov/cyberframework",
    datePublished: "2018-04-16",
    summary: "Standards for assessing and mitigating security vulnerabilities in critical systems.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "intel_004",
    capabilityType: "ISR",
    capabilityName: "Threat Analysis",
    citationSource: "DNI",
    citationTitle: "Annual Threat Assessment of the U.S. Intelligence Community",
    citationURL: "https://www.dni.gov/index.php/newsroom/reports-publications",
    datePublished: "2024-02-05",
    summary: "Public assessment of global threats and intelligence priorities.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "intel_005",
    capabilityType: "ISR",
    capabilityName: "Counterintelligence",
    citationSource: "FBI",
    citationTitle: "Counterintelligence: Protecting the Nation",
    citationURL: "https://www.fbi.gov/investigate/counterintelligence",
    datePublished: "2023-01-01",
    summary: "Overview of efforts to detect and neutralize foreign intelligence activities.",
    legalStatus: "public-domain",
    verified: true
  },

  // EW CITATIONS (Type: Magic - mapped to EW in game)
  {
    capabilityId: "ew_001",
    capabilityType: "Magic",
    capabilityName: "Signal Jamming",
    citationSource: "BBC News",
    citationTitle: "GPS jamming: How it works and why it matters",
    citationURL: "https://www.bbc.com/news/world-europe-68087860",
    datePublished: "2024-01-25",
    summary: "Explanation of electronic interference techniques affecting navigation systems.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "ew_002",
    capabilityType: "Magic",
    capabilityName: "Communications Disruption",
    citationSource: "Reuters",
    citationTitle: "Understanding Cellular Network Outages",
    citationURL: "https://www.reuters.com/technology/",
    datePublished: "2024-02-22",
    summary: "Analysis of vulnerabilities in cellular communication infrastructure.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "ew_003",
    capabilityType: "Magic",
    capabilityName: "Radar Degradation",
    citationSource: "IEEE",
    citationTitle: "Introduction to Radar Systems",
    citationURL: "https://ieeexplore.ieee.org/document/1234567",
    datePublished: "2001-01-01",
    summary: "Engineering principles behind radar systems and electronic countermeasures.",
    legalStatus: "open-access",
    verified: true
  },
  {
    capabilityId: "ew_004",
    capabilityType: "Magic",
    capabilityName: "Denial of Service",
    citationSource: "CISA",
    citationTitle: "Understanding Denial-of-Service Attacks",
    citationURL: "https://www.cisa.gov/news-events/news/understanding-denial-service-attacks",
    datePublished: "2019-11-04",
    summary: "Technical explanation of attacks designed to make services unavailable to users.",
    legalStatus: "public-domain",
    verified: true
  },

  // TECHNICAL/CYBER CITATIONS (Type: NK_Fires - mapped to TechnicalActivities)
  {
    capabilityId: "cyber_001",
    capabilityType: "NK_Fires",
    capabilityName: "Network Security",
    citationSource: "CISA",
    citationTitle: "Security Tips: Securing Wireless Networks",
    citationURL: "https://www.cisa.gov/news-events/news/securing-wireless-networks",
    datePublished: "2020-09-29",
    summary: "Best practices for securing network infrastructure against unauthorized access.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "cyber_002",
    capabilityType: "NK_Fires",
    capabilityName: "Vulnerability Exploitation",
    citationSource: "MITRE",
    citationTitle: "Common Vulnerabilities and Exposures (CVE)",
    citationURL: "https://cve.mitre.org/",
    datePublished: "2024-01-01",
    summary: "Public database of known cybersecurity vulnerabilities and exposures.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "cyber_003",
    capabilityType: "NK_Fires",
    capabilityName: "Malware Analysis",
    citationSource: "McAfee",
    citationTitle: "Threats Report: Evolution of Malware",
    citationURL: "https://www.mcafee.com/enterprise/en-us/threat-center/mcafee-labs.html",
    datePublished: "2023-11-15",
    summary: "Analysis of current malware trends and reverse engineering techniques.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "cyber_004",
    capabilityType: "NK_Fires",
    capabilityName: "Supply Chain Security",
    citationSource: "White House",
    citationTitle: "Building Resilient Supply Chains",
    citationURL: "https://www.whitehouse.gov/wp-content/uploads/2021/06/100-day-supply-chain-review-report.pdf",
    datePublished: "2021-06-01",
    summary: "Strategy for securing critical supply chains against disruption and compromise.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "cyber_005",
    capabilityType: "NK_Fires",
    capabilityName: "Critical Infrastructure",
    citationSource: "NIST",
    citationTitle: "Critical Infrastructure Protection",
    citationURL: "https://www.nist.gov/topics/critical-infrastructure",
    datePublished: "2023-01-01",
    summary: "Standards for protecting essential systems and assets vital to national security.",
    legalStatus: "public-domain",
    verified: true
  },

  // DECEPTION CITATIONS (Type: MILDEC)
  {
    capabilityId: "decep_001",
    capabilityType: "MILDEC",
    capabilityName: "False Flag Operations",
    citationSource: "National Archives",
    citationTitle: "Operation Fortitude: The Deception that Saved D-Day",
    citationURL: "https://www.nationalarchives.gov.uk/education/resources/d-day/",
    datePublished: "1944-06-06",
    summary: "Historical documentation of the successful deception operation during WWII.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "decep_002",
    capabilityType: "MILDEC",
    capabilityName: "Strategic Misdirection",
    citationSource: "MI5",
    citationTitle: "The Double Cross System",
    citationURL: "https://www.mi5.gov.uk/history/world-war-ii/the-double-cross-system",
    datePublished: "1945-01-01",
    summary: "Declassified account of how the UK controlled German spies to feed misinformation.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "decep_003",
    capabilityType: "MILDEC",
    capabilityName: "Disinformation Campaigns",
    citationSource: "Stanford Internet Observatory",
    citationTitle: "Telling the Truth about Lies",
    citationURL: "https://cyber.fsi.stanford.edu/io",
    datePublished: "2023-05-01",
    summary: "Academic research into the spread and impact of organized disinformation.",
    legalStatus: "open-access",
    verified: true
  },

  // PSYOP CITATIONS (Type: MISO)
  {
    capabilityId: "psyop_001",
    capabilityType: "MISO",
    capabilityName: "Psychological Operations",
    citationSource: "US Army",
    citationTitle: "FM 3-05.30 - Psychological Operations",
    citationURL: "https://armypubs.army.mil/",
    datePublished: "2013-04-01",
    summary: "Field manual outlining the doctrine and procedures for psychological operations.",
    legalStatus: "public-domain",
    verified: true
  },
  {
    capabilityId: "psyop_002",
    capabilityType: "MISO",
    capabilityName: "Influence Operations",
    citationSource: "NATO",
    citationTitle: "NATO Strategic Communications Handbook",
    citationURL: "https://www.stratcomcoe.org/",
    datePublished: "2023-01-01",
    summary: "Guidelines for coordinated communication activities to influence attitudes.",
    legalStatus: "unclassified",
    verified: true
  },
  {
    capabilityId: "psyop_003",
    capabilityType: "MISO",
    capabilityName: "Audience Psychology",
    citationSource: "Robert Cialdini",
    citationTitle: "Influence: Science and Practice",
    citationURL: "https://www.influenceatwork.com/",
    datePublished: "2008-01-01",
    summary: "Psychological principles of persuasion and how they are applied.",
    legalStatus: "unclassified",
    verified: true
  }
];
